import type { FaireProductEntity } from "../../entity_types/product";

export const p_kdbrkbfzaz: FaireProductEntity = {
  token: "p_kdbrkbfzaz",
  type: "product",
  name: "Big Butt Energy Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/48ddcba4e7f01b1eec550f5533be65f8eb89d28e277db03fe857a848cdb3eb9b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8597cff12276dd8124b9e08120d30a393395a92f22b31317f3c90e7cb6c35bd5.jpeg",
    "https://cdn.faire.com/fastly/40cc16b8c25386d7a68dd89f78b78586f189b062615a762a12f8222a766706f4.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/2f073ef7869c8a77f6e29891d8de081b7062de24813c4e487f300eeb5c86ad5b.jpeg",
    "https://cdn.faire.com/fastly/fd0593e2e89fa2e891e81941cd2916079a5439fefd2e12b95ee6eb89a9aa992c.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nIf you have a cheeky attitude, these socks are for you. Whether you have the confident swagger of someone packin' major trunk, or if you literally beep when you back up... you've found the right pair! 🍑 🧦\n\nA hilarious and body-positive gift for birthdays, bachelorettes, or your booty-loving bestie. These funny  socks are made to celebrate curves and confidence with cheeky flair.\n\nKey features of our Big Butt Energy gym socks:\n\n• Unisex sizing\n• One size fits most \n• Comfy cushion foot\n• No toe seam\n• Made with high quality cotton in the USA\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:20.754Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
